import React from 'react';
import Operators from './Operators';
import Conditions from './Conditions';
import Statement from './Statement';
import { useTranslation } from 'react-i18next';

const CellFormatingIfStatement = (props) => {
    const { t } = useTranslation([
        "attribute/cell_formatting",
    ]);
    const { updateStatement, removeStatement, statement, attribute } = props;
    const { color, colorOption, operator, condition1, condition2 } = statement;
    const attributeType = attribute.attributeType === "Mirror" ? attribute.attribute.attributeType : attribute.attributeType;

    const handleOperatorChange = (value) => {
        const updatedStatement = { ...statement, operator: value };
        updateStatement(updatedStatement);
    }

    const handleCondition1Change = (value) => {
        const updatedStatement = { ...statement, condition1: value };
        updateStatement(updatedStatement);
    }

    const handleCondition2Change = (value) => {
        const updatedStatement = { ...statement, condition2: value };
        updateStatement(updatedStatement);
    }

    const handleColorOptionChange = (value) => {
        const updatedStatement = { ...statement, colorOption: value };
        updateStatement(updatedStatement);
    }

    const handleColorChange = (value) => {
        const updatedStatement = { ...statement, color: value };
        updateStatement(updatedStatement);
    }

    const handleRemoveStatement = () => {
        removeStatement(statement.id);
    }

    return (
        <div className="row mb-3 pb-3 border-bottom">
            <div className="col-2">
                <label className="col-form-label">
                    {t("if_statement")}
                </label>
            </div>
            <Operators
                attributeType={attributeType}
                operator={operator}
                onOperatorChange={handleOperatorChange}
            />
            <Conditions
                attribute={attribute}
                operator={operator}
                condition1={condition1}
                onChangeCondition1={handleCondition1Change}
                condition2={condition2}
                onChangeCondition2={handleCondition2Change}
            />
            <div className="col-12">
                <Statement
                    label={t("then_statement")}
                    color={color}
                    onColorChange={handleColorChange}
                    colorOption={colorOption}
                    onColorOptionChange={handleColorOptionChange}
                    removeTitle={t("remove_if_condition")}
                    onRemove={handleRemoveStatement}
                />
            </div>
        </div>
    );
};

export default CellFormatingIfStatement;